import React from "react";
import { Skeleton } from "../@/components/ui/skeleton";

interface SkeletonProps {
  rows: number;
}

const SkeletonAddEditCategoryDialog: React.FC<SkeletonProps> = ({ rows }) => {
  return (
    <div className="max-w-[37vw]">
      <div className="max-h-[32rem] overflow-y-auto">
        {[...Array(rows)].map((_, index) => (
          <div key={index} className="mt-4 px-2">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="mt-2 h-10 w-full" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkeletonAddEditCategoryDialog;
